'use strict';
import $ from "jquery";
export default class HomeContent {
  constructor() {
    this.name = 'home-content';
    console.log('%s module', this.name.toLowerCase());
  }
}


